module.exports = __webpack_public_path__ + "static/media/fb.ec7947b7.svg";